
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./components/contact-component');
require('./components/faq-expand-component');
require('./components/multi-level-navigation-component');
require('./components/not-found-component');
require('./components/sorting-component');
require('./components/video-component');

import Vue from 'vue';
import Headroom from "headroom.js";
import { debounce } from 'lodash';
import { gsap } from 'gsap';
import 'lazysizes';
import zenScroll from 'zenscroll';


const App = new Vue({
    el: '#app',
    delimiters: ['${', '}'],

    data() {
        return {
            // isMobile: false,
            // isTablet: false
            showMobileMenu: false,
            headroom: null,
            headroomEl: null,
        }
    },

    watch: {
        showMobileMenu: function (visible) {
            console.log(visible);
            EventBus.$emit("navigation-state-changed", visible);
            if (!visible) {
                gsap.set(document.body, {
                    overflow: null
                });
                return;
            }

            gsap.set(document.body, {
                overflow: "hidden"
            });
        }
    },

    mounted() {
        this.headroomEl = document.querySelector('.header-headroom-holder');
        this.headroom = new Headroom(this.headroomEl);
        this.headroom.init();

        window.addEventListener('resize', this.onWindowResize);

        gsap.delayedCall(.5, () => {
            if (window.location.hash) {
                const el = document.querySelector(window.location.hash);
                zenScroll.to(el);
            }
        });
    },

    methods: {
        /**
         * Raised when the client window is resizing.
         *
         * @return {Void}
         */
        onWindowResize: debounce(() => {
            EventBus.$emit('window-resize');
        }, 150),

        detectMobile() {
            this.isMobile = (window.innerWidth <= 768);
            this.isTablet = (window.innerWidth <= 1024);
            console.log(`Is Mobile: ${this.isMobile}`)
        }
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onWindowResize);
    }
});
